module.exports = __webpack_public_path__ + "5469241aaf99345a0a3ac2d9f4d71165.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-construction-s.png
// module id = 2870
// module chunks = 0